/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Component, Input, OnInit } from '@angular/core';
import { IcecontrolSettings, IcecontrolPermission } from '../../components/models/icesettings';

@Component({
  selector: 'icecanvas',
  templateUrl: './icecanvas.component.html',
  styleUrls: ['./icecanvas.component.css']
})
export class IcecanvasComponent implements OnInit {
  @Input() id: string = "";
  @Input() ctrl: IcecontrolSettings = null;

  constructor() { }

  ngOnInit() {
  }

}
